<template>
  <div class="diagram-tooltip">
    <div
      ref="tooltipWrapper"
      class="diagram-tooltip__hover-wrapper"
    >
      <div
        v-for="(dev,devIndex) in length"
        :key="devIndex"
        class="diagram-tooltip__hover"
        @mousemove="$_setIngHover($event,devIndex)"
        @mouseout="$_unsetIngHover()"
      />
      <div
        ref="tooltipContent"
        class="diagram-tooltip__tooltip"
        :class="{active: ingHoverIndex > -1}"
        :style="[{bottom:ingHoverYPosition},{left:ingHoverXPosition}]"
      >
        <p class="diagram-tooltip__tooltip__title">
          {{ Object.keys(tooltips)[ingHoverIndex] }}
        </p>
        <div class="diagram-tooltip__tooltip__tooltip-content">
          <div
            v-for="(tooltip,tooptipKey) in tooltips[Object.keys(tooltips)[ingHoverIndex]]"
            :key="tooptipKey"
            class="diagram-tooltip__tooltip__tooltip-row"
          >
            <div
              v-if="tooltip.label"
              class="diagram-tooltip__tooltip__tooltip-row-label"
            >
              <div
                class="diagram-tooltip__tooltip__tooltip-row-label_block"
                :style="{height:`${labelHeight}px`,width:`${labelWidth}px`,backgroundColor:tooltip.label,borderRadius:`${labelRadius}px`}"
              />
            </div>
            <div class="diagram-tooltip__tooltip__tooltip-row-title">
              {{ $t(tooltip.title) }}
            </div>
            <div class="diagram-tooltip__tooltip__tooltip-row-content">
              {{ tooltip.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "DiagramTooltip",
  props: {
    tooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    length: {
      type: Number,
      default: 0,
    },
    labelWidth: {
      type: Number,
      default: 14,
    },
    labelHeight: {
      type: Number,
      default: 14,
    },
    labelRadius: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    ingHoverIndex: -1,
    ingHoverXPosition: 0,
    ingHoverYPosition: 0,
    ingMouseClientX: 0,
    ingMouseClientY: 0,
  }),
  methods: {
    $_setIngHover($event, index) {
      this.ingHoverIndex = index;
      this.ingMouseClientX = $event.clientX;
      this.ingMouseClientY = $event.clientY;
      this.$_getTooltipPosition(index);
      this.$emit("hover-in", this.ingHoverIndex);
    },
    $_unsetIngHover() {
      this.$emit("hover-out");
      this.ingHoverIndex = -1;
      this.ingMouseClientX = 0;
      this.ingMouseClientY = 0;
    },
    $_getTooltipPosition() {
      let tooltipWrap = this.$refs.tooltipWrapper.getBoundingClientRect();
      let tooltipWidth = this.$_getTooltipWidth();
      let tooltipMaxLeft = tooltipWrap.right;
      let tooltipXPosition =
        this.ingMouseClientX - tooltipWrap.left - tooltipWidth / 2;
      if (tooltipXPosition + tooltipWidth > tooltipMaxLeft - tooltipWrap.left) {
        tooltipXPosition = tooltipMaxLeft - tooltipWidth - tooltipWrap.left;
      } else if (tooltipXPosition <= 0) {
        tooltipXPosition = 0;
      }
      this.ingHoverXPosition = `${tooltipXPosition}px`;
      this.ingHoverYPosition = `${
        tooltipWrap.top - this.ingMouseClientY + tooltipWrap.height + 20
      }px`;
    },
    $_getTooltipWidth() {
      if (!this.$refs.tooltipContent) return 0;
      const tooltipContent = this.$refs.tooltipContent.getBoundingClientRect();
      return tooltipContent.width;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-tooltip";
</style>